var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instructionLink"},[_c('a',{staticClass:"underline text-primary",attrs:{"href":_vm.linkUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('LayoutAdmin.navbar.instruction')))])])}
var staticRenderFns = []

export { render, staticRenderFns }